// Shared by page slugs (use-page-editor.ts) and the unit slug fallback
// (use-org-profile.ts) — same transformation, same "page"/"unit" fallback
// shape for an input with no sluggable characters at all.
export function slugify(value: string, fallback = "page"): string {
  return (
    value
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)/g, "") || fallback
  );
}
